export default __webpack_public_path__ + "static/media/JavaDevelopers300.ab877617.jpg";